export const GUEST_USER_ROLE_ID = 18;

// DR_Name and DRM_ID from the API are GROUP_CONCAT strings (e.g. "Admin,Consultant" / "1,6").
// Both helpers split on comma so multi-role users are handled correctly.

export function isGuestUser(drmId) {
    if (drmId == null) return false;
    return drmId.toString().split(",").map(s => s.trim()).includes(GUEST_USER_ROLE_ID.toString());
}

export function hasRole(drName, roleName) {
    if (!drName || !roleName) return false;
    return drName.toString().split(",").map(s => s.trim()).includes(roleName);
}

export default isGuestUser;
